import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

export function QuizDeliveryMethodQuestionOption({
  imageSrc,
  isSelected,
  onChange,
  name,
  subtitle,
  title,
  value
}) {
  const htmlId = value ? `${name}-${value}` : name;
  const labelClass = 'AdoptionApplicationQuestionOption__label';
  return (
    <label
      className={classnames(labelClass, 'transition h-100 db br1 pointer', {
        'AdoptionApplicationQuestionOption__label--selected': isSelected
      })}
      htmlFor={htmlId}
    >
      <input
        checked={isSelected}
        className="AdoptionApplicationQuestionOption__input dn outline-0"
        id={htmlId}
        name={name}
        onClick={onChange}
        onChange={() => {}}
        type="checkbox"
        value={value}
      />
      <div className="mb2 aspect-ratio aspect-ratio--4x3">
        <div className="aspect-ratio--object">
          <SmartImage
            Tag="div"
            className="w-100 h-100 br1 br--top bg-center cover"
            src={imageSrc}
          />
        </div>
      </div>
      <div className="ph4 pb4">
        <p className="fw-medium">{title}</p>
        {subtitle && <p className="mt2 db f2">{subtitle}</p>}
      </div>
    </label>
  );
}

QuizDeliveryMethodQuestionOption.propTypes = {
  imageSrc: PropTypes.string,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

QuizDeliveryMethodQuestionOption.defaultProps = {
  imageSrc: null,
  isSelected: false,
  name: null,
  subtitle: null,
  title: null,
  value: null
};

export default function QuizDeliveryMethodQuestion({
  availableDeliveryOptions,
  handleNextClick,
  isValid,
  onSubmit
}) {
  return (
    <div className="AdoptionApplicationQuizDeliveryMethodQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title="How do you want to bring your puppy home?"
        subtitle="Select the transportation options you’re interested in."
        onSubmit={onSubmit}
      >
        <ul className="row justify-center flex-lg-nowrap tc">
          {availableDeliveryOptions.map((option, idx) => (
            <li className="mb8 col-sm-auto col-6" key={idx}>
              <QuizDeliveryMethodQuestionOption
                isSelected={option.isSelected}
                name={option.inputName}
                onChange={option.onSelect}
                subtitle={option.subtitle}
                title={option.title}
                value={option.value}
                imageSrc={option.imageSrc}
              />
            </li>
          ))}
        </ul>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizDeliveryMethodQuestion.propTypes = {
  availableDeliveryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      inputName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      isSelected: PropTypes.bool.isRequired,
      onSelect: PropTypes.func.isRequired,
      imageSrc: PropTypes.string.isRequired
    })
  ).isRequired,
  handleNextClick: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func
};

QuizDeliveryMethodQuestion.defaultProps = {
  onSubmit: null
};
